﻿import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerPlus } from '@fortawesome/pro-regular-svg-icons';

import { Modal, Button } from 'antd';
import { ExternalLayersStore } from '../../stores/ExternalLayersStore';
import LayerTable from './LayerTable';
import LayerModal from './LayerModal';
import { ExternalChartLayer } from './LayerInterfaces';
import { ExternalLayerTypes } from './LayerTypes';

interface Props {
    visible: boolean,
    layers: ExternalChartLayer[],
    externalLayersStore: ExternalLayersStore,
    onOk: () => void, //return obejct met settings
}

const externalLayerDefaults = {
    id: -1,
    name: "",
    capabilitiesUrl: "",
    url: "",
    layers: [],
    matrixSet: "",
    type: ExternalLayerTypes.WMS
};

const ExternalLayersModal: React.FC<Props> = ({ visible, layers, externalLayersStore, onOk }) => {

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [layer, setLayer] = useState<ExternalChartLayer>();

    const onModalOk = () => {
        onOk();
    }

    const onLayerModalOk = (layer: ExternalChartLayer) => {
        if (layer.id == -1)
            externalLayersStore.addLayer(layer);
        else
            externalLayersStore.updateLayer(layer);

        setLayer(undefined);
    }

    const onLayerModalCancel = () => {
        setLayer(undefined);
    }

    const onAddLayerClicked = () => {
        setLayer({ ...externalLayerDefaults });        
        setIsModalVisible(true);
    }

    const onEditLayer = (layer: ExternalChartLayer) => {
        setLayer(layer);
        setIsModalVisible(true);
    }

    const onRemoveLayer = (id: number) => {
        externalLayersStore.removeLayer(id);
    }


    return (
        <Modal title="External layers" open={visible} closable={false} width="80%" onOk={onModalOk} footer={[
            <Button key="submit" type="primary" onClick={onModalOk}>Ok</Button> 
        ]}>
            <Button onClick={onAddLayerClicked} icon={<FontAwesomeIcon icon={faLayerPlus} />} type="primary" style={{ marginBottom: 16 }} />


            <LayerModal
                layer={layer}
                onOk={onLayerModalOk}
                onCancel={onLayerModalCancel} />

            <LayerTable layers={layers} pagination={false} onEdit={onEditLayer} onRemove={onRemoveLayer} />
        </Modal>
    )
}

export default ExternalLayersModal;